<!--
 * @Descripttion: 未描述
 * @version: 1.0.0
 * @Author: Chendajiang
 * @Date: 2019-06-25 19:16:18
 * @LastEditors: Chendajiang
 * @LastEditTime: 2019-08-13 18:07:02
 -->
<template>
  <div class="Gongview_pag" style="margin:0 auto;">
    <div>
      <el-pagination
        hide-on-single-page
        @current-change="handleCurrentChange"
        :current-page="param.pageNum"
        layout="prev, pager, next, jumper"
        :pager-count="11"
        :page-size="param.pageSize"
        :total="param.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  components: {},
  data() {
    return {};
  },
  props: {
    param: {
      type: Object,
      required: true
    }
  },
  computed: {},
  methods: {
    handleCurrentChange(val) {
      // 分页点击事件
      this.param.pageNum = val;
      this.$emit("changeDataList", val);
      this.scrollTop();
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
  watch: {},
  created() {},
  mounted() {}
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.Gongview_pag {
  text-align: center;
}
</style>
<style>
.el-pager li {
  background-color: transparent;
}
.el-pagination .btn-next,
.el-pagination .btn-prev {
  background-color: transparent;
}
.el-pagination button:disabled {
  background-color: transparent;
}
>>>.el-input__inner {
  background-color: transparent;
}

.el-pager li.active {
  color: #B79255;
}
</style>

